import { useField } from 'formik'




export const Label = ({ children }) => (
  <span className="text-[0.812rem] sm:text-[0.875rem] font-medium text-[#9CA3AF]">{children}</span>
)

export const TextField = ({ name, placeholder, type = 'text' }) => {
  const [field] = useField(name)
  return (
    <input
      {...field}
      type={type}
      placeholder={placeholder}
      className="w-full rounded-[10px] border border-solid border-[#D9D9D9] bg-white px-[1rem] sm:px-[1.5rem] py-[0.75rem] sm:py-[1rem] text-[0.938rem] sm:text-[1rem] text-[#111827] placeholder:text-[#D9D9D9] outline-none focus:border-[#0D9488]"
    />
  )
}

export const TextareaField = ({ name, placeholder, rows = 6 }) => {
  const [field] = useField(name)
  return (
    <textarea
      {...field}
      rows={rows}
      placeholder={placeholder}
      className="w-full resize-none rounded-[10px] border border-solid border-[#D9D9D9] bg-white px-[1rem] sm:px-[1.5rem] py-[0.75rem] sm:py-[1rem] text-[0.938rem] sm:text-[1rem] text-[#111827] placeholder:text-[#D9D9D9] outline-none focus:border-[#0D9488]"
    />
  )
}

export const AddLink = ({ children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-[0.5rem] self-start border-none bg-transparent p-0 text-[0.938rem] sm:text-[1rem] font-medium text-[#0D9488] hover:text-[#0F766E] cursor-pointer"
  >
    <span className="text-[1.25rem] leading-none">+</span>
    {children}
  </button>
)

export const Section = ({ title, children, className = '' }) => (
  <section className={`flex flex-col gap-[1rem] sm:gap-[1.5rem] ${className}`}>
    <h2 className="m-0 text-[1.25rem] sm:text-[1.5rem] font-semibold text-[#111827]">{title}</h2>
    {children}
  </section>
)
